// The video editor's URL. The route is `/editor/[video_id]` and the segment is
// the SHORT — the same id a publication carries in `projectId` — so nothing
// else has to be resolved to link there: no folder, no export row.
//
// One helper because both calendars now open the editor from a post's `…`
// menu, and "the same editor URL logic in both contexts" has to mean one
// definition rather than two matching template literals. (The ten older inline
// `/editor/${id}` literals elsewhere in the app are left alone; this is not a
// sweep.)

export const editorHrefForVideo = (videoId: string): string =>
  `/editor/${videoId}`;
